export const UTM_C_IMPORT = 'UTM_C_IMPORT';
export const UTM_R_IMPORT = 'UTM_R_IMPORT';
export const UTM_C_PROFILE = 'UTM_C_PROFILE';
export const UTM_R_PROFILE = 'UTM_R_PROFILE';
export const UTM_U_PROFILE = 'UTM_U_PROFILE';
export const UTM_D_PROFILE = 'UTM_D_PROFILE';
export const UTM_R_ASSET = 'UTM_R_ASSET';
export const UTM_C_ALLOCATIONUNIT = 'UTM_C_ALLOCATIONUNIT';
export const UTM_R_ALLOCATIONUNIT = 'UTM_R_ALLOCATIONUNIT';
export const UTM_U_ALLOCATIONUNIT = 'UTM_U_ALLOCATIONUNIT';
export const UTM_D_ALLOCATIONUNIT = 'UTM_D_ALLOCATIONUNIT';
export const UTM_C_COSTOBJECT = 'UTM_C_COSTOBJECT';
export const UTM_R_COSTOBJECT = 'UTM_R_COSTOBJECT';
export const UTM_U_COSTOBJECT = 'UTM_U_COSTOBJECT';
export const UTM_D_COSTOBJECT = 'UTM_D_COSTOBJECT';
export const UTM_C_RULE = 'UTM_C_RULE';
export const UTM_R_RULE = 'UTM_R_RULE';
export const UTM_U_RULE = 'UTM_U_RULE';
export const UTM_D_RULE = 'UTM_D_RULE';
export const UTM_C_MAP = 'UTM_C_MAP';
export const UTM_R_MAP = 'UTM_R_MAP';
export const UTM_U_MAP = 'UTM_U_MAP';
export const UTM_D_MAP = 'UTM_D_MAP';
export const UTM_R_TARGET = 'UTM_R_TARGET';
export const UTM_C_TRANSLATIONTABLE = 'UTM_C_TRANSLATIONTABLE';
export const UTM_R_TRANSLATIONTABLE = 'UTM_R_TRANSLATIONTABLE';
export const UTM_U_TRANSLATIONTABLE = 'UTM_U_TRANSLATIONTABLE';
export const UTM_D_TRANSLATIONTABLE = 'UTM_D_TRANSLATIONTABLE';
export const UTM_C_REPORT = 'UTM_C_REPORT';
export const UTM_R_REPORT = 'UTM_R_REPORT';
export const UTM_U_REPORT = 'UTM_U_REPORT';
export const UTM_D_REPORT = 'UTM_D_REPORT';
export const UTM_C_TAXCALC = 'UTM_C_TAXCALC';
export const UTM_R_TRANSACTION = 'UTM_R_TRANSACTION';
export const UTM_U_TRANSACTION = 'UTM_U_TRANSACTION';
export const UTM_D_TRANSACTION = 'UTM_D_TRANSACTION';
export const UTM_R_LINES = 'UTM_R_LINES';
export const UTM_U_LINES = 'UTM_U_LINES';
export const UTM_D_LINES = 'UTM_D_LINES';
export const UTM_U_LINESTATUS = 'UTM_U_LINESTATUS';
export const UTM_C_SFTPCREDENTIAL = 'UTM_C_SFTPCREDENTIAL';
export const UTM_R_SFTPCREDENTIAL = 'UTM_R_SFTPCREDENTIAL';
export const UTM_R_ORGANIZATION = 'UTM_R_ORGANIZATION';



// WEBPACK FOOTER //
// ./src/shared/constants/PermissionsConstants.js